import script from "./AttendeeForm.vue?vue&type=script&setup=true&lang=js"
export * from "./AttendeeForm.vue?vue&type=script&setup=true&lang=js"

import "./AttendeeForm.vue?vue&type=style&index=0&id=517cb238&lang=css"

const __exports__ = script;

export default __exports__